import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _mutations;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import Drip from 'drip';
import { API_GET_GROUP_LIST } from '@/apis';
import { GET_GROUP_LIST, MUTATE_GROUP_LIST, MUTATE_GROUP_PAGING, GETTER_GROUP_LIST, GETTER_GROUP_PAGING } from '@/constants/group-list';
function getDefaultShopDetail() {
  return {
    groups: [],
    paging: {
      hasMore: true,
      pageNo: 1,
      pageSize: 15,
      totalHits: 0
    }
  };
}
export default {
  state: getDefaultShopDetail(),
  actions: _defineProperty({}, GET_GROUP_LIST, function (_ref) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, state, _state$paging, pageNo, pageSize, cityId, _axios$get$then, code, data, paging;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, state = _ref.state;
            _state$paging = state.paging, pageNo = _state$paging.pageNo, pageSize = _state$paging.pageSize;
            cityId = Drip.constant.cityId;
            _axios$get$then = axios.get(API_GET_GROUP_LIST({
              cityId: cityId,
              pageNo: pageNo,
              pageSize: pageSize
            })).then(function (_ref2) {
              var code = _ref2.code,
                data = _ref2.data,
                paging = _ref2.paging;
              if (code === 200) {
                commit(MUTATE_GROUP_LIST, data);
                commit(MUTATE_GROUP_PAGING, paging);
              }
            }).catch(function (err) {
              console.warn(err);
            }), code = _axios$get$then.code, data = _axios$get$then.data, paging = _axios$get$then.paging;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }),
  mutations: (_mutations = {}, _defineProperty(_mutations, MUTATE_GROUP_LIST, function (state, groups) {
    state.groups = groups;
  }), _defineProperty(_mutations, MUTATE_GROUP_PAGING, function (state, paging) {
    state.paging = paging;
  }), _mutations),
  getters: {
    GETTER_GROUP_LIST: function GETTER_GROUP_LIST(state) {
      return state.groups;
    },
    GETTER_GROUP_PAGING: function GETTER_GROUP_PAGING(state) {
      return state.paging;
    }
  }
};